<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="data"
      :rowsPerPageItems="[stockListMeta.item_per_page]"
      :server-items-length="totalNumberOfItems"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-options': [stockListMeta.item_per_page],
        'disable-items-per-page': true,
      }"
      :options.sync="options"
      class="elevation-1"
      :mobile-breakpoint="0"
    >
      <template v-slot:item.other_store_btn="{ item }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="onClickButton(item)"
        >
          ดูสาขาอื่น
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    data: Object,
  },

  watch: {
    options: {
      handler() {
        this.refetch()
      },
      deep: true,
    },
  },

  computed: {
    ...mapState({
      me: (state) => state.me.data,
      stockListMeta: (state) => state.stock.stockListMeta,
      isLoading: (state) => state.stock.isLoading,
    }),

    totalNumberOfItems() {
      return +this.stockListMeta?.total_items
    },

    pagination() {
      return {
        // descending: !!this.$route.query.desc,
        // sortBy: this.$route.query.orderby || 'name',
        rowsPerPage:
          +this.$route.query.limit ||
          this.stockListMeta?.item_per_page,
        page: +this.$route.query.page,
        totalItems: this.totalNumberOfItems,
        itemsLength: this.totalNumberOfItems,
      }
    },
  },

  data() {
    return {
      options: {
        page: +this.$route.query.page || 1,
      },
      firstLoad: false,
      headers: [
        // {
        //   text: 'SKU',
        //   align: 'start',
        //   sortable: false,
        //   value: 'sku',
        // },
        { text: 'ชื่อ', value: 'name', maxwidth: '100px' },
        { text: 'ร้าน', value: 'current_store', maxwidth: '5px' },
        { text: 'OS', value: 'all_online_store', maxwidth: '5px' },
        { text: 'คลัง', value: 'all_warehouse', maxwidth: '5px' },
        { text: 'อื่นๆ', value: 'other_store', maxwidth: '5px' },
        // { text: 'All Avaliable', value: 'all_avaliable' },
        { text: 'PO', value: 'delivery_date', maxwidth: '5px' },
        {
          text: '',
          value: 'other_store_btn',
          align: 'center',
          maxwidth: '5px',
          fixed: true,
        },
      ],

      items: [
        {
          sku: '4777711122212',
          product_name: 'iPhone 14 Pro Max 128GB',
          brand: 'Apple',
          available_stock: 24,
          online_stock: 4,
          offline_stock: 2,
          total_stock: 30,
          reserved_stock: 6,
          commited_stock: 0,
        },
        {
          sku: '4777711122213',
          product_name: 'iPhone 14 Pro Max 256GB',
          brand: 'Apple',
          available_stock: 22,
          online_stock: 5,
          offline_stock: 2,
          total_stock: 32,
          reserved_stock: 6,
          commited_stock: 3,
        },
      ],
    }
  },

  methods: {
    onClickButton(item) {
      this.$emit('select')
      this.$router.push({
        name: 'StockDetail',
        query: {
          sku: item.sku,
        },
      })
    },

    async refetch() {
      if (this.firstLoad) {
        const { page } = this.options
        await this.$store.dispatch('stock/getStockList', {
          sku: this.$route.query?.sku,
          name: this.$route.query?.name || undefined,
          page: page,
        })
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            name: this.$route.query?.name || undefined,
            sku: this.$route.query?.sku || undefined,
            page,
          },
        })
      }
      this.firstLoad = true
    },

    // async paginate(val) {
    //   console.log('paginate', val)
    //   const query = this.$route.query
    //   const obj = Object.assign({}, query)
    //   obj.page = val.page ?? query.page
    //   await this.$store.dispatch('stock/getStockList', {
    //     sku: this.sku,
    //     name: this.name,
    //     page: obj.page,
    //   })

    //   this.$router.replace({
    //     ...this.$router.currentRoute,
    //     query: obj,
    //   })
    // },
  },
}
</script>

<style lang="stylus" scoped>
::v-deep .theme--light.v-data-table .v-data-footer
  display: flex
  justify-content: flex-end

::v-deep .v-data-table
  overflow-x: auto;

//::v-deep table > tbody > tr > td:nth-last-child(1),
//::v-deep table > thead > tr > th:nth-last-child(1)
//  position: sticky !important
//  position: -webkit-sticky !important
//  right: 0
//  z-index: 1
//  background: white
//::v-deep table > thead > tr > th:nth-last-child(1)
//  z-index: 9999;
</style>
